import { create } from '@storybook/theming/create'
import logo from '../assets/arla-logo.png'

export default create({
  base: 'light',
  brandTitle: 'Design system',
  brandImage: logo
})
